import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store'
import i18n from './i18n'
import router from "./router";
import './assets/css/main.css'

import apolloClient from './apollo'
import {setGraphQlClientToProviders} from '@dracul/user-frontend'
import {customizationProvider} from '@dracul/customize-frontend'
import {notificationProvider} from '@dracul/notification-frontend'
setGraphQlClientToProviders(apolloClient)
customizationProvider.setGqlc(apolloClient)
notificationProvider.setGqlc(apolloClient)
notificationProvider.setGqlcWs(apolloClient)

Vue.config.productionTip = false

//Customization instances inject
store.commit('setVuetifyInstance', vuetify)

//1. Load from localstore; preset español por defecto (Dracul trae 'en' por defecto)
const lang = store.state.customization.language
i18n.locale = lang === 'en' ? 'es' : (lang || 'es')
//2. Load from backend (desactivado temporalmente para no llamar al backend en login)
// store.dispatch('loadCustomizations')
//     .then(r => {
//       i18n.locale = r.language
//     })


new Vue({
  vuetify,
  store,
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
